/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';

@classNames('posts')
export default class PrintPostList extends Component {
  // includeAuthorImages specifies whether to show authors' profile images.
  includeAuthorImages = true;

  // includeLegalName specifies whether to include the students legal name.
  includeLegalName = false;

  // includeImages specifies whether to show images attached to Posts.
  includeImages = true;

  // includeOtherMedia specifies whether to list other media attached to Posts.
  includeOtherMedia = false;

  // includeComments specifies whether to show comments on Posts.
  includeComments = false;
}
